module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M27.522 21.728a4.991 4.991 0 0 0-3.494-1.364l-1.846-7.574a8.118 8.118 0 0 1-3.038 1.572l1.746 7.164c-.158.128-.32.248-.462.4a5.016 5.016 0 0 0 .2 7.094 5.016 5.016 0 0 0 7.094-.198 5.016 5.016 0 0 0-.2-7.094z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/ingredient-highlight.js
// module id = 1192
// module chunks = 14